import ContactForm from '../ContactForm';
import Container from '../Container';
import Heading from '../Heading';
import bannerStyle from './banner.module.css'

const BannerContact = ({heading,description,locations=[]}) => {
    return (
        <section className={`${bannerStyle['section-3']} ${bannerStyle['bg-styler']} ${bannerStyle['overlay']} d-flex align-items-center`} style={{backgroundImage:"url(/banner/contact-banner.jpg)"}}>
            <Container className="py-5">
                <div className='row'>
                    <div className='col-12 col-lg-6'>
                        <div className={`${bannerStyle['content']}`}>
                            <h1>{heading || ''}</h1>
                            <p dangerouslySetInnerHTML={{__html:description}} />
                        </div>
                        {locations && locations.length > 0 &&
                            <div className={`${bannerStyle['location']} mt-3`}>
                                <h2>Locations</h2>                                
                                <div className={`${bannerStyle['location-area']} row mt-4`}>
                                    {locations.map((item,index) =>
                                        <div className='col-12 col-sm-6 mb-4' key={index}>
                                            <div className={bannerStyle['location-card']}>
                                                <span>{item.area}</span>
                                                <address>
                                                    <a href={item.address} title={item.address}>{item.address}</a>
                                                </address>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        
                    </div>
                    <div className='col-12 col-lg-6'>
                        <div className={`${bannerStyle['contact-form']} ms-0 ms-xl-5`}>
                            <Heading 
                                heading={'Get a free quote now'}
                            />
                           <ContactForm className="mt-5" />
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default BannerContact;